import { ArrowUp } from "@/svg";
import * as Ariakit from "@ariakit/react";
import { SVGIcon } from "hsl-core/Components";
import * as styles from "./Accordion.css";

type AccordionTab = {
	title: string;
	content: React.ReactNode;
};
type Props = {
	tabs: AccordionTab[];
	className?: string;
	openIndex?: number;
	onChange?: (openIndex?: number) => void;
};

export default function Accordion({
	tabs,
	className,
	openIndex,
	onChange,
}: Props) {
	// const [openIndex, setOpenIndex] = useState<number>();
	return (
		<div className={`${styles.container} ${className}`}>
			{tabs.map((tab, i) => (
				<Ariakit.DisclosureProvider
					key={`${tab.title}-${i}`}
					open={openIndex === i}
					setOpen={() =>
						i === openIndex ? onChange?.(undefined) : onChange?.(i)
					}
				>
					<Ariakit.Disclosure className={styles.button}>
						{tab.title}
						<SVGIcon
							icon={ArrowUp}
							className={styles.arrow({ open: openIndex === i })}
						/>
					</Ariakit.Disclosure>
					<Ariakit.DisclosureContent className={styles.content}>
						{tab.content}
					</Ariakit.DisclosureContent>
				</Ariakit.DisclosureProvider>
			))}
		</div>
	);
}
